import React, { Component } from "react";

const VoiceIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 11"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0)" fill={fill}>
        <path d="M6.84 3.76c.002.676-.223 1.334-.64 1.874l.84.624c.556-.72.856-1.6.855-2.504a4.094 4.094 0 00-.86-2.502l-.837.628c.419.54.645 1.2.643 1.88z" />
        <path d="M8.708 0l-.837.628a5.122 5.122 0 011.075 3.128A5.121 5.121 0 017.88 6.887l.84.625A6.143 6.143 0 0010 3.754 6.144 6.144 0 008.708 0zM3.682 1.686a2.13 2.13 0 00-1.17.348c-.346.227-.616.55-.775.929a2.038 2.038 0 00.456 2.256c.294.289.669.486 1.077.566.409.08.832.039 1.216-.118.385-.157.714-.422.945-.763a2.045 2.045 0 00-.263-2.612 2.124 2.124 0 00-1.486-.606zm0 3.104c-.208 0-.412-.06-.584-.174a1.038 1.038 0 01-.387-.465 1.018 1.018 0 01.228-1.127 1.057 1.057 0 011.146-.223c.192.078.357.21.472.38a1.022 1.022 0 01-.131 1.306 1.062 1.062 0 01-.744.303zM6.181 7.094a4.24 4.24 0 00-.837-.692 3.194 3.194 0 01-3.327.006c-.309.195-.59.428-.837.693C-.24 8.633.017 10.713.017 10.713c1.211.2 2.437.296 3.665.287a21.557 21.557 0 003.666-.287c.002 0 .26-2.087-1.167-3.619zm-2.495 2.87c-.87 0-1.738-.046-2.602-.139.021-.193.057-.384.105-.572a3.25 3.25 0 01.95-1.63c.993.381 2.095.38 3.087-.004.49.457.828 1.048.97 1.696.04.169.071.34.091.512a24.51 24.51 0 01-2.602.137h.001z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H10V11H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

VoiceIcon.defaultProps = {
  fill: "#8D0053",
  width: 10,
  height: 11,
};

export default VoiceIcon;
